import React from "react";
import EmptyRealEstate from "../EmptyRealEstate/EmptyRealEstate";
import Table from "../Table2";
import { Observer, observer } from "mobx-react";
import {
  numWithUnit,
  // trackEventWithScreen,
} from "../../utils/functions";
import SortTable from "../../utils/Hooks/SortTable";
import UserStore from "../../store/UserStore";
// import { PORTFOLIO_PAGE, REAL_ESTATE } from "../../utils/constants";

const RealEstateSummary = observer(({ hasData }) => {
  const realEstateData = UserStore.realEstateData;

  const {
    isAscending: isRealEstateAscendig,
    key1: realSortKey,
    arrData: realContentData,
    setKeyForOrdering: setRealEstateOrder,
  } = SortTable(
    realEstateData,
    {
      key1: "name",
    },
    true,
  );

  // const handleImageUpload = (id, pic, name) => {
  //   setSelectedId(id);
  //   setSelectedPic(pic);
  //   setSelectedName(name);
  //   setUploadImageModalOpen(true);
  // };

  const instrumentNameCellRenderer = (_, data, key) => {
    if (key === "g_is_est")
      return (
        <div className="transaction_date_cell font-roboto data-wrapper">
          {numWithUnit(data[key].value, data[key].value_type)}
        </div>
      );
    if (key === "sales_value_est")
      return (
        <div className="transaction_date_cell font-roboto data-wrapper">
          {numWithUnit(data[key].value, data[key].value_type)}
        </div>
      );
    if (key === "values" || key === "paids" || key === "dues") {
      return (
        <div className="transaction_date_cell font-roboto data-wrapper">
          {numWithUnit(data[key].value, data[key].value_type)}
        </div>
      );
    }
    return (
      <div className="transaction_date_cell data-wrapper">{data[key]}</div>
    );
  };
  const realEstateNameCellRenderer = (_, data, key) => {
    return (
      <Observer>
        {() => {
          return (
            <div className="real_estate_name_cell">
              {/* <div
                className="image_container"
                onClick={() =>
                  getDecodedToken()?.user_type === "customer" &&
                  handleImageUpload(data.id, data.profile_pic, data.name)
                }
              >
                <img
                  className={
                    data?.profile_pic &&
                    getDecodedToken()?.user_type === "customer"
                      ? "real_estate_image cursor"
                      : data?.profile_pic
                      ? "real_estate_image"
                      : getDecodedToken()?.user_type === "customer"
                      ? "cursor"
                      : ""
                  }
                  src={
                    data?.profile_pic && UserStore.realEstateImage?.[data.id]
                      ? UserStore.realEstateImage?.[data.id]
                      : noImageForEstate
                  }
                  alt="real estate"
                />
              </div> */}
              <div className="real_estate_details_container">
                <p className="estate_name">{data[key]}</p>
                <p className="user_name">{data.owner}</p>
              </div>
            </div>
          );
        }}
      </Observer>
    );
  };

  // const AddImageModalContent = () => {
  //   const fileRef = useRef();
  //   const uploadFile = (fileVar) => {
  //     const file = getSelectedFile(fileVar);
  //     const validation = validateFile(file);
  //     switch (validation) {
  //       case "file type error":
  //         setUploadMessage({
  //           message: "Only JPEG and PNG image formats are supported",
  //           isError: true,
  //         });
  //         setImage(null);
  //         break;
  //       case "file size error":
  //         setUploadMessage({
  //           message: "File size larger than 10 MB",
  //           isError: true,
  //         });
  //         setImage(null);
  //         break;
  //       case "valid file":
  //         setUploadMessage({
  //           message: "",
  //           isError: false,
  //         });
  //         setImage(file);
  //         break;
  //       default:
  //         break;
  //     }
  //   };

  //   const validateFile = (file) => {
  //     const allowedFileExtention = [".png", ".jpeg", ".jpg"];
  //     const fileExtention = file.name.substring(file.name.lastIndexOf("."));
  //     const isFileSizevalid = file.exactSize < 10485760;
  //     const isFileTypeValid = allowedFileExtention.includes(
  //       fileExtention.toLowerCase()
  //     );
  //     if (!isFileTypeValid) {
  //       return "file type error";
  //     }
  //     if (!isFileSizevalid) {
  //       return "file size error";
  //     }
  //     if (isFileSizevalid && isFileTypeValid) {
  //       return "valid file";
  //     }
  //   };

  //   const getFileSize = (size, decimals = 2) => {
  //     if (size === 0) return "0 Bytes";

  //     const k = 1024;
  //     const dm = decimals < 0 ? 0 : decimals;
  //     const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  //     const i = Math.floor(Math.log(size) / Math.log(k));
  //     return parseFloat(size / Math.pow(k, i)).toFixed(dm) + " " + sizes[i];
  //   };

  //   const getSelectedFile = (file) => {
  //     if (file) {
  //       const fileSrc = URL.createObjectURL(file);
  //       return {
  //         name: file.name,
  //         size: getFileSize(file.size),
  //         exactSize: file.size,
  //         type: file.type,
  //         src: fileSrc,
  //         file: file,
  //       };
  //     } else {
  //       return null;
  //     }
  //   };

  //   const handleFileClick = () => {
  //     if (!image) {
  //       fileRef.current.click();
  //     }
  //   };

  //   const handleDrop = (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     const dt = e.dataTransfer;
  //     const file = dt.files[0];
  //     uploadFile(file);
  //   };

  //   const hanldeInpuChange = (e) => {
  //     e.preventDefault();
  //     const _file = e.target.files[0];
  //     uploadFile(_file);
  //   };

  //   const stopDefault = (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();
  //   };

  //   const getImageType = (type) => {
  //     switch (type) {
  //       case "image/png":
  //         return "PNG";
  //       case "image/jpeg":
  //         return "JPEG";
  //       case "image/jpg":
  //         return "JPG";
  //       default:
  //         return "PNG";
  //     }
  //   };

  //   const handleUpload = () => {
  //     if (image) {
  //       setIsPictureUploading(true);
  //       setIsPicApiCall(true);
  //       UserStore.uploadRealEstateImage({
  //         image: image.file,
  //         realestateId: selectedId,
  //         onSuccess: () => {
  //           setIsPicApiCall(false);
  //           setUploadMessage({
  //             message: "Image uploaded successfully",
  //             isError: false,
  //           });

  //           setTimeout(() => {}, 1300);
  //           setTimeout(() => {
  //             PerformanceStore.setCurrentLoader("mainTabLoader");
  //             PerformanceStore.setPerformanceLoader("mainTabLoader", true);
  //             UserStore.getRealEstateData();
  //             setIsPictureUploading(false);
  //             setUploadImageModalOpen(false);
  //           }, 1000);
  //         },
  //         onFail: (err) => {},
  //       });
  //     }
  //   };

  //   return (
  //     <>
  //       {isPicApiCall && (
  //         <div className="loader_container">
  //           <div className="footer_loader_container2">
  //             <img className="loader_gif" src={loaderGIF} alt="loading..." />
  //           </div>
  //         </div>
  //       )}
  //       <div className="add_image_container">
  //         <div className="default_image_name_wrapper1">
  //           <p className={`message ${uploadMessage.isError ? "red_text" : ""}`}>
  //             {uploadMessage.message}
  //           </p>
  //           <button onClick={handleFileClick}>
  //             <img
  //               // onClick={handleFileClick}
  //               src={
  //                 image
  //                   ? image.src
  //                   : selectedPic && UserStore.realEstateImage?.[selectedId]
  //                   ? UserStore.realEstateImage?.[selectedId]
  //                   : defaultImageForEstate
  //               }
  //               alt="default"
  //               className={`${
  //                 image
  //                   ? "radius"
  //                   : selectedPic
  //                   ? "border_radius"
  //                   : "cursor_pointer"
  //               } clickable`}
  //             />
  //           </button>

  //           <p className="user_name">{selectedName}</p>
  //         </div>
  //         {image ? (
  //           <div className="selected_image_container">
  //             <img src={imageIcon} alt="icon" />
  //             <p className="file_details">
  //               {image.name} - {image.size} {getImageType(image.type)} format
  //             </p>
  //             {!isPictureUploading && (
  //               <button className="remove_btn" onClick={() => setImage(null)}>
  //                 Remove
  //               </button>
  //             )}
  //           </div>
  //         ) : (
  //           <div
  //             onDragEnter={stopDefault}
  //             onDragOver={stopDefault}
  //             onDrop={handleDrop}
  //             className="drap_and_drop_container_border"
  //           >
  //             <div className="drap_and_drop_container">
  //               <p className="drag_drop_text">Drag and drop your image </p>
  //               <p className="file_support_text">
  //                 Files Supported: JPEG, PNG and Maximum Size: 10 MB
  //               </p>
  //             </div>
  //             <input
  //               onChange={hanldeInpuChange}
  //               type="file"
  //               accept="image/png, image/jpeg"
  //               style={{ display: "none" }}
  //               ref={fileRef}
  //             />
  //           </div>
  //         )}

  //         <div className="bottom_button_container">
  //           <button
  //             style={{ display: "none" }}
  //             className="cencel_btn"
  //             onClick={handleCancel}
  //           >
  //             Cancel
  //           </button>
  //           {!isPictureUploading && (
  //             <ArrowButton
  //               type="next"
  //               label="Save"
  //               disabled={!image}
  //               onClick={handleUpload}
  //             />
  //           )}
  //         </div>
  //       </div>
  //     </>
  //   );
  // };

  const columns2 = [
    {
      label: "Real Estate Name / Proprietor Name ",
      key: "name",
      sortable: true,
      cellRenderer: realEstateNameCellRenderer,
      isMultipleSort: true,
      position: { top: "60px", left: "100px" },
      forArrowCheck: "instrument_nameactualWholeObject",
      multiSortBox: [
        {
          key: "name",
          show: "Real Estate Name",
        },
        {
          key: "owner",
          show: "Owner",
        },
      ],
      headerLabel: "Sort By Real Estate Name With Owner",
    },
    {
      label: "Type",
      key: "type",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Value",
      key: "values",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Paid",
      key: "paids",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Due",
      key: "dues",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Sale Value (est)",
      key: "sales_value_est",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
    {
      label: "Gain / Loss",
      key: "g_is_est",
      sortable: true,
      cellRenderer: instrumentNameCellRenderer,
    },
  ];

  const handleSorting = (key) => {
    if (key === "g_is_est" || key === "sales_value_est") {
      setRealEstateOrder({
        key1: key,
        key2: "actual_value",
      });
    } else if (key === "type" || key === "name") {
      setRealEstateOrder({
        key1: key,
      });
    } else {
      setRealEstateOrder({
        key1: key,
        key2: "actual_value",
      });
    }
  };

  // const handleCancel = () => {
  //   setUploadMessage({
  //     message: "",
  //     isError: false,
  //   });
  //   setImage(null);
  //   setUploadImageModalOpen(false);
  // };

  //useEffect(() => {
  // trackEventWithScreen({
  //   eventName: PORTFOLIO_PAGE,
  //   screenName: REAL_ESTATE,
  // });
  //}, []);

  if (hasData) {
    return (
      <div className="real_estate_summary">
        {!!realEstateData && !!realEstateData.length ? (
          <>
            <div className="real_estate_summary_heading">
              <h2 className="real_estate_summary_heading_text">
                Real Estate Summary
              </h2>
              {/* <h2 className="portfolio_breadcr_title"></h2> */}
            </div>

            <Table
              data={realContentData}
              columns={columns2}
              tableClass="equity_summary_table"
              sortKey={realSortKey}
              isAscending={isRealEstateAscendig}
              handleSort={(key) => handleSorting(key)}
            />
          </>
        ) : (
          <EmptyRealEstate />
        )}

        {/* <Modal
          onClose={handleCancel}
          open={uploadImageModalOpen}
          title="Add Image"
          width={"800px"}
          showCloseIcon={!isPictureUploading}
        >
          <AddImageModalContent
            selectedId={selectedId}
            uploadMessage={uploadMessage}
            setUploadMessage={setUploadMessage}
            image={image}
            setImage={setImage}
            handleCancel={handleCancel}
          />
        </Modal> */}
      </div>
    );
  } else {
    return (
      <div className="no_real_estate_summaries">
        <EmptyRealEstate />
      </div>
    );
  }
});

export default RealEstateSummary;
